<template>
  <transition
    v-if="showModal"
    name="modal-fade"
  >
    <div class="modal-backdrop">
      <div
        id="delCustModal"
        class="modal delCustModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                id="exampleModalLabel"
                class="modal-title"
              >
                Kunde löschen
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="delCustModal"
                aria-label="Close"
                @click="hideModal()"
              >
                <span
                  class="x-position"
                  aria-hidden="true"
                >&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>Sind Sie sicher, dass Sie den Kunden</p>
              <p><strong>{{ customer.forename }} {{ customer.surname }} {{ customer.customer_nr != ''? '( ' + customer.customer_nr + ' )' : '' }} </strong></p>
              <p>und alle dazugehörigen Objekte und Dokumente löschen wollen?</p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="delCustModal"
                aria-label="Close"
                @click="hideModal()"
              >
                Nein
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="deleteCustomer()"
              >
                Löschen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['customer'],
  data () {
    return {
      showModal: false
    }
  },
  methods: {
		deleteCustomer () {
			this.$axios.delete(process.env.VUE_APP_BASE_URI + 'customer/' + this.customer.id)
				.then(() => {
					this.hideModal();
					this.$parent.clearPickedObject();
				})
		},
    showDelete () {
      this.showModal = true
      let element = document.getElementById("delCustModal")
      $(element).modal('show')
    },
    hideModal () {
      this.showModal = false
      let element = document.getElementById("delCustModal")
      $(element).modal('hide')
    }
  }
}
</script>
<style scoped>
.modal-dialog {
	height: 330px !important;
}
.modal-position {
  left: 50%;
  top: 80%;
  transform: translate(-50%, -50%);
}
.modal {
	padding-top: 0;
	height: 387px !important;
}
.x-position {
  position: relative;
  top: -11px;
  right: 6px;
}
</style>
